import { differenceInSeconds } from 'date-fns';
export const getDate = (date) => {
    return `${date.getDate()}-${date.getMonth()}-${date.getFullYear()}`;
};

export const getTime = (date) => {
    return `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
};

export const timeDifference = (seconds = 0) => {
    const hour = Math.floor(seconds / 3600);
    const min = Math.floor(seconds / 60) % 60;
    const sec = (seconds - min * 60) % 60;
    return `${hour && hour + 'h'} ${min && min + 'm'} ${sec && sec + 's'}`;
};

export const timeLeftForBid = (time) => {
    return timeDifference(differenceInSeconds(
        new Date(time),
        new Date()
    ));
};